<template>
	<div class="templatebody" :style="note">
		<div>
			<heard></heard>
		</div>
		<div class="flex-all-center margin-top-l">
			<div class="back-color-white" style="width: 45%;">
				<div class="back-color-db query-title-text-margins">
					<p class="text-white sl-p">运单轨迹一键查询，掌握精准时间节点</p>
				</div>
				<div class="query-title-margin">
					    <div class="edit" id="appst">
					        <div id="leftBox"><textarea wrap="off" cols="2" id="leftNum" disabled></textarea></div>
					        <textarea @input="handleTextareaInput" v-model="areatext" placeholder="请输入您的运单号,并以换行进行分隔" onscroll="document.getElementById('leftNum').scrollTop = this.scrollTop;" id="edit-content"></textarea>
					</div>
					<div class="margin-top-l">
						<el-button class="text-white  bt" type="primary" @click="nameber()"> 运 单 查 询 <i class="el-icon-search el-icon--right"></i>   
						</el-button>
					</div>
				</div>
			</div>
		</div>
		<div class="buttom-text">
			<p>版权所有：海南云航翊信息科技有限责任公司 Copyright © 2014.Company name All rights reserved.</p>
		</div>
	</div>
</template>
<script>
	import "@/assets/css/home.css"
	import "@/assets/css/public.css"
	import heard from './public/heard.vue'
	export default {
		name: 'Home',
		components: {
			heard
		},
		data() {
			return {
				el:'appst',
				areatext: '',
				num: '',
				note: {
					backgroundImage: "url(" + require("./../assets/img/bg-map.png") + ")",
					backgroundRepeat: "no-repeat",
					backgroundSize: "100% 100%",
				},
			}
		},
		mounted() {
			  this.handleTextareaInput({target: {value: this.areatext}})
		},
		methods: {
			 handleTextareaInput(e) {
			            var str = e.target.value
			            str = str.replace(/\r/g,"");
			            str = str.split("\n");
			            let n = str.length;
			            var lineobj = document.getElementById("leftNum");
			            for(var i = 1;i <= n;i ++){
			                if(document.all){
			                    this.num += i + "\r\n";   //判断浏览器是否是IE  
			                }else{
			                    this.num += i + "\n";
			                }
			            }
			            lineobj.value = this.num;
			            this.num = "";
			        },

			nameber() {
				
				// 不为空判断
				if(this.areatext!==''&&this.areatext!==undefined)
				{
						this.$router.push({
							name:'queryok',
							params:{
							       input1:this.areatext
							     }
						})
						localStorage.setItem('oderNumber',this.areatext)
				}
				else if(this.areatext=='')
				{
					 this.$message({
					          message: '请输入正确内容进行查询',
					          type: 'warning'
					        });
				}
				
				
				// let set = this.textarea
				// let arr = set.split("\n")
				// console.log(arr)
				// this.$source.post('/v1/flight_order/track', {
				// 		"order_no": arr
				// 	}, )
				// 	.then((res) => {
				// 		console.log(res)
				// 	}, (err) => {
				// 		console.log(err)
				// 	});
			},
		}
	}
</script>
<style  scoped>
	textarea {
		background-color: #ffffff;
		height: 270px;
		padding-top: 10px;
		padding-right: 10px;
		padding-left: 10px;
		padding-bottom: 10px;
		overflow: auto;
		color: green;
		font-size: 16px;
		border: 1px inset ThreeDLightShadow;
		outline: none;
	}

	.el-button--primary {
		background-color: #FD9405;
		border-color: #FD9405;
		font-size: 18px;
	}

	.el-button--primary:hover {
		background-color: #FD9405;
		border-color: #FD9405;
	}

	.el-button--primary:focus {
		background-color: #FD9405;
		border-color: #FD9405;
	}
	
	i {
	    font-size: 16px;
	    color: #FFFFFF;
	    margin-left: 20px;
	}
	.templatebody{
		min-height: 95vh;
	}
	.bt{
		width: 300px;
	}

</style>



// WEBPACK FOOTER //
// src/components/SecondPage.vue